import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import { convertToHTML } from "draft-convert";
import { EditorState } from "draft-js";
import React, { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactPlayer from "react-player";
import { Link, useHistory, useParams } from "react-router-dom";
import { serverInfo } from "../../../../../../App";
import useFileHandleS3 from "../../../../../../CustomHooks/useFileHandleS3";
import useThumbnailHandleS3 from "../../../../../../CustomHooks/useThumbnailHandleS3";
import useVdieoHandleS3 from "../../../../../../CustomHooks/useVideoHandleS3";
import MediaUploadProgressBar from "../../../../../../Screen/MediaUploadProgressBar";
import "./AddSessionTextEditor.css";
import useVideoHandleWithCompress from "../../../../../../CustomHooks/useVideoHandleWithCompress";

export default function EditSimplePost(props) {
  const { imageCdnUrl ,videoCdnUrl } = useContext(serverInfo);
  const params = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const [errorList, setErrorList] = useState([]);

  // Editor Funtionalities //
  const [convertedContent, setConvertedContent] = useState(null);


  // End Editor Functionalies //
  const [starList, setStarList] = useState([]);


  const [postType, setPostType] = useState("");
  const [paymentType, setPaymentType] = useState("");
  function handleType(e) {
    setPostType(e.target.value);
  }
  function handleType2(e) {
    setPaymentType(e.target.value);
  }

  // File Handle
  const fileInputRef = useRef(null);
  const [filePath, setFilePath] = useState("");
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl, fileKey, progress] = useFileHandleS3(file, 'post/images', delKey);

  // Video File Handle
  const videoInputRef = useRef(null);
  const [videoPath, setVideoPath] = useState("");
  const [video, setVideo] = useState('');
  const [videoDelKey, setVideoDelKey] = useState(null);
  const [videoUrl, videoKey, videoProgress, videoHeight,videoWidth] = useVideoHandleWithCompress(video, 'post/videos', videoDelKey);


  // Thumbnail File Handle
  const thumbInputRef = useRef(null);
  const [thumbPath, setThumbPath] = useState("");
  const [thumbnail, setThumbnail] = useState('');
  const [thumbnailDelKey, setThumbnailDelKey] = useState(null);
  const [thumbImageUrl, thumbImageKey, thumbProgress] = useThumbnailHandleS3(thumbnail, 'post/videos/thumbnail', thumbnailDelKey);


  const [registerInput, setRegister] = useState({
    title: "",
    description: "",
    video: "",
    star_id: "",
    fee: "",
    error_list: [],
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setRegister((prev) => {
      return { ...prev, [name]: value };
    });
  };

  // Fetch Stars Added By Admin
  useEffect(() => {
    axios.get(`/api/admin/star_list`).then((res) => {
      if (res.status === 200) {
        setStarList(res.data.star);
      }
    });
    axios.get(`/api/admin/simple_post/pending/${params.id}`).then((res) => {
      if (res.status === 200) {
        setRegister(res.data.post);
        setPaymentType(res.data.post.type);
        setPostType(res.data.post.post_type);
        setVideoPath(res.data.post.video?res.data.post.video:'');
        setFilePath(res.data.post?.image?res.data.post?.image:'');
        setThumbPath(res.data.post?.thumbnail?res.data.post?.thumbnail:'');
        console.log(res.data.post);
      }
    });
  }, []);

  // Image handle
  const handleChange = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };

  const deleteFile = () => {
    setFile('');
    setDelKey(fileKey);
    fileInputRef.current.value = '';
  }
  // Video handle
  const handleChangeVideo = (file) => {
    setVideoDelKey(videoKey);
    setVideo('');
    setVideo(file[0]);
  };

  const deleteVideo = () => {
    setVideo('');
    setVideoDelKey(videoKey);
    videoInputRef.current.value = '';
  }

  // Thumbnail handle
  const handleThumbnail = (file) => {
    setThumbnailDelKey(thumbImageKey);
    setThumbnail(file[0]);
  };

  // const deleteThumbnail = () => {
   
  //   setThumbnail('');
  //   setThumbnailDelKey(thumbImageKey);
  //   thumbInputRef.current.value = '';
  // }

  const deleteThumbnail = () => {
    axios.get(`/api/admin/simple_post/pending/thumbnail/${params.id}`).then((res) => {
      if (res.status === 200) {
          console.log(res.data.message);
      }
    });
    
  }

  const registerSubmit = (e) => {
    setLoading(true);
    e.preventDefault();

    const fData = new FormData();

    console.log(fData);

    fData.append("image", fileKey ? fileKey : filePath);
    fData.append("video", videoKey ? videoKey: videoPath);
    fData.append("thumbnail", thumbImageKey ? thumbImageKey : thumbPath);
    fData.append("title", registerInput.title);
    fData.append("star_id", registerInput.star_id);
    fData.append("description", convertedContent);
    fData.append("fee", registerInput.fee);
    fData.append("type", paymentType);
    fData.append("post_type", postType);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/admin/simple_post/update/${params.id}`, fData)
        .then((res) => {
          setLoading(false);
          if (res.data.status === 402) {
            setErrorList(res.data.errors);
          } else {
            if (file) {
              setFile('');
              setDelKey(filePath.split("com/").pop())
            }
            if (video) {
              setVideo('');
              setVideoDelKey(videoPath.split("com/").pop())
            }
            if (thumbnail) {
              setThumbnail('');
              setThumbnailDelKey(thumbPath.split("com/").pop())
            }
            history.push("/superstar-admin/post/pending");
          }
        });
    });
  };


  return (
    <>
      <div className="text-light d-flex border border-warning rounded-3 justify-content-center p-2 mb-3">
        <div className="faTrophy">
          <i className="fa-solid fa-calendar-plus"></i>
        </div>
        <h4 className="mx-3 text-warning pt-1 p-2">Edit Post</h4>
      </div>

      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form
                  className="p-3"
                  onSubmit={registerSubmit}
                  id="input_form"
                  encType="multipart/form-data"
                >
                  <div className="form-group row my-4">
                    <label className="col-sm-3 label-text ">
                      Select Star
                    </label>
                    <div className="col-sm-9">
                      <select
                        onChange={handleInput}
                        name="star_id"
                        className="form-control reply-control"
                        value={registerInput.star_id}
                      >
                        <option className="text-black" value="">
                          Choose One
                        </option>
                        {starList.map((star, index) => (
                          <option className="text-black" value={star.id}>
                            {star.first_name} {star.last_name}
                          </option>
                        ))}
                      </select>
                      <span className="text-danger">
                        {errorList.star_id}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-4 ">
                    <label className="col-sm-3 label-text ">
                      Post Type
                    </label>
                    <div className="col-sm-3 mb-3">
                      <select
                        onChange={handleType}
                        value={postType}
                        className="form-control reply-control"
                        selected
                      >
                        <option className="text-black">
                          Select Post Type
                        </option>
                        <option className="text-black" value="general">
                          General
                        </option>
                        <option className="text-black" value="video">
                          Video
                        </option>
                      </select>
                      <span className="text-danger">
                        {errorList.post_type}
                      </span>
                    </div>

                    <label className="col-sm-3 label-text text-md-end text-lg-end">
                      Payment Type
                    </label>
                    <div className="col-sm-3">
                      <select
                        onChange={handleType2}
                        name="type"
                        className="form-control reply-control"
                        value={paymentType}
                        selected
                      >
                        <option className="text-black" value="">
                          Select Payment Type
                        </option>
                        <option className="text-black" value="free">
                          Free
                        </option>
                        <option className="text-black" value="paid">
                          Paid
                        </option>
                      </select>
                      <span className="text-danger">
                        {errorList.type}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-4">
                    <label className="col-sm-3 label-text ">Title</label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control reply-control"
                        placeholder="Enter title here...!"
                        onChange={handleInput}
                        name="title"
                        value={registerInput.title}
                      />
                      <span className="text-danger">
                        {errorList.title}
                      </span>
                    </div>
                  </div>

                  <div className="form-group row my-4">
                    <label className="col-sm-3 label-text ">
                      Description
                    </label>
                    <div className="col-md-9">
                      <CKEditor
                        editor={ClassicEditor}
                        data={registerInput.description}

                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setConvertedContent(data);
                        }}

                      />
                      <span className="text-danger">
                        {errorList.description}
                      </span>
                    </div>
                  </div>
                  {postType === "general" ? (
                    <div className="form-group row my-3">
                      <label className="col-sm-3 label-text ">
                        Banner
                      </label>
                      <div className="col-sm-5 file-x-i">
                        {fileUrl && file ? (
                          <div className="position-relative">

                            <img
                              src={fileUrl}
                              className="img-fluid avatar-img-src"
                              alt=""
                              style={{ maxHeight: "300px",maxWidth:"400px" }}
                            />
                            <span className="text-warning right-cross-button" onClick={deleteFile}>X</span>
                          </div>
                        ) : (
                          <img
                            src={imageCdnUrl + filePath}
                            className="img-fluid avatar-img-src"
                            alt=""
                            style={{ maxHeight: "300px",width:"400px"  }}
                          />
                        )}
                        <input
                          type="file"
                          accept="image/*"
                          className="form-control reply-control"
                          onChange={(e) => handleChange(e.target.files)}
                          id="image"
                          name="image"
                          ref={fileInputRef}
                        />
                        {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {postType === "video" ? (
                    <>
                      <div className="form-group row my-3">
                        <label className="col-sm-3 label-text ">
                          Video
                        </label>
                        <div className="col-sm-7 file-x-i">

                          {videoUrl && video ? (

                            <div className="position-relative">
                              <ReactPlayer
                                url={videoUrl}
                                controls
                                playing={false}
                                volume={1}
                                width="100%"
                                height="200px" // style={{ margin: "0 auto" }}
                              />
                              <span className="text-warning right-cross-button" onClick={deleteVideo}>X</span>
                            </div>


                          ) : <ReactPlayer
                            url={videoCdnUrl + videoPath}
                            controls
                            playing={false}
                            volume={1}
                            width="100%"
                            height="200px" // style={{ margin: "0 auto" }}
                          />}
                          <input
                            type="file"
                            accept="video/*"
                            className="form-control reply-control mb-3"
                            onChange={(e) => handleChangeVideo(e.target.files)}
                            id="video"
                            name="video"
                            ref={videoInputRef}
                          />
                          {video && !videoUrl && <MediaUploadProgressBar progress={videoProgress} />}

                          <span className="text-danger">{errorList.video}</span>
                        </div>
                      </div>
                      <div className="form-group row my-3">
                        <label className="col-sm-3 label-text ">
                          Thumbnail
                        </label>
                        <div className="col-sm-7 file-x-i">
                          {thumbImageUrl && thumbnail ? (
                            <div className="position-relative">
                              <img
                                src={thumbImageUrl}
                                className="demo-preview-image img-fluid"
                                alt=""
                                style={{ height: "200px", width: "400px" }}
                              />
                              <span className="text-warning right-cross-button" onClick={deleteThumbnail}>X</span>
                            </div>

                          ) : (
                            <div className="position-relative">
                              <img
                                src={imageCdnUrl+thumbPath}
                                className="demo-preview-image img-fluid"
                                alt=""
                                style={{ height: "200px", width: "400px" }}
                              />
                              <span className="text-warning right-cross-button" onClick={deleteThumbnail}>X</span>
                             </div>
                          )}
                          <input
                            type="file"
                            accept="image/*"
                            className="form-control reply-control mb-3"
                            onChange={(e) => handleThumbnail(e.target.files)}
                            id="thumbnail"
                            name="thumbnail"
                            ref={thumbInputRef}
                          />
                          {thumbnail && !thumbImageUrl && <MediaUploadProgressBar progress={thumbProgress} />}

                          <span className="text-danger">
                            {errorList.thumbnail}
                          </span>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {paymentType === "paid" ? (
                    <div className="form-group row my-4">
                      <label className="col-sm-3 label-text ">Fees</label>
                      <div className="col-sm-5">
                        <input
                          type="number"
                          min={0}
                          className="form-control reply-control"
                          placeholder="Enter fee $"
                          onChange={handleInput}
                          name="fee"
                          value={registerInput.fee}
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* Update Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3"></div>
                    <div className="col-md-9 d-flex justify-content-center aligns-items-center ">
                      <Link to={`/superstar-admin/post/pending`}>
                        <button className="btn btnGoBack fw-bold me-2">
                          Go Back
                        </button>
                      </Link>
                      {loading ? (
                        <>
                          <button className="btn btnUpdate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button
                          className="btn btnUpdate fw-bold"
                          type="submit"
                        >
                          Update
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Update Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

}
